import {propOr} from 'ramda';

import {ApiError} from 'shared/web';

export const is404ApiError = (error?: ApiError) => {
  const status = propOr(null, 'status', error);
  const originalStatus = propOr(null, 'originalStatus', error);

  return status === 404 || originalStatus === 404;
};
